<div class="alert-settings">
  <div class="toolbar">
    <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
      <mat-label>Filter alert types</mat-label>
      <input matInput [(ngModel)]="filterText" (ngModelChange)="applyFilter()" data-testid="alert-settings-filter" />
    </mat-form-field>
    @if (canManageEnabled) {
      <mat-checkbox [(ngModel)]="enabledOnly" (change)="applyFilter()" data-testid="alert-settings-enabled-only">
        Enabled only
      </mat-checkbox>
    }
    <span class="spacer"></span>
    @if (changeCount > 0) {
      <span class="muted">{{ changeCount }} unsaved {{ changeCount === 1 ? 'change' : 'changes' }}</span>
    }
    <span class="saved-status" aria-live="polite">{{ changeCount === 0 ? statusMessage : '' }}</span>
    <button mat-stroked-button type="button" (click)="discardChanges()" [disabled]="changeCount === 0 || saving"
      data-testid="alert-settings-discard">
      Discard
    </button>
    <button mat-raised-button color="accent" type="button" (click)="save()" [disabled]="changeCount === 0 || saving"
      data-testid="alert-settings-save">
      Save
    </button>
  </div>

  @if (loading) {
    <div class="muted">Loading alert settings…</div>
  } @else if (rows.length === 0) {
    <div class="muted">
      {{ canManageEnabled ? 'There are no alert types yet.' : 'No alerts are enabled for your corporation.' }}
    </div>
  } @else if (tableRows.length === 0) {
    <div class="muted">No alert types match your filter.</div>
  } @else {
    <table mat-table [dataSource]="tableRows" class="alert-settings-table">
      <ng-container matColumnDef="group">
        <td mat-cell *matCellDef="let group" [attr.colspan]="displayedColumns.length" class="group-cell">
          <div class="group-header">
            @if (canManageEnabled) {
              <mat-checkbox
                [checked]="isGroupFullyEnabled(group)"
                [indeterminate]="isGroupPartiallyEnabled(group)"
                (change)="setGroupEnabled(group, $event.checked)"
                [aria-label]="'Enable all ' + group.label + ' alerts shown'">
              </mat-checkbox>
            }
            <span class="group-label">{{ group.label }}</span>
            @if (canManageEnabled) {
              <span class="muted">{{ enabledCount(group.rows) }} of {{ group.rows.length }} enabled</span>
            }
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="enabled">
        <th mat-header-cell *matHeaderCellDef class="enabled-cell">Enabled</th>
        <td mat-cell *matCellDef="let row" class="enabled-cell">
          <mat-checkbox [(ngModel)]="row.enabled" [aria-label]="'Enable ' + row.alertType.name"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Alert Type</th>
        <td mat-cell *matCellDef="let row">{{ row.alertType.name }}</td>
      </ng-container>

      <ng-container matColumnDef="severity">
        <th mat-header-cell *matHeaderCellDef class="severity-cell">Severity</th>
        <td mat-cell *matCellDef="let row" class="severity-cell">
          <mat-form-field appearance="outline" class="severity-field" subscriptSizing="dynamic">
            <mat-select [(ngModel)]="row.severity" [disabled]="!row.enabled" [aria-label]="'Severity for ' + row.alertType.name">
              <mat-option [value]="defaultSeverity">Default ({{ row.alertType.defaultAlertSeverityID }})</mat-option>
              @for (option of severityOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let group; columns: ['group']; when: isGroupRow" class="group-row"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.changed-row]="isRowChanged(row)"></tr>
    </table>
  }
</div>
